import styled from 'styled-components';
import AreaIconSvg from '../assets/hotels/home/area.svg';

const AreaIcon = styled(AreaIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  fill: ${props => props.fill || props.theme.colors.grey.grey50};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default AreaIcon;
